import React from "react";
import { useLocation } from "react-router";

export function useUrlQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function useFromFyntune() {
  const urlQuery = useUrlQuery();
  const enquiryId = urlQuery.get("enquiryId");
  const source = urlQuery.get("source");

  return enquiryId && source === "fyntune";
}
